var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshCw05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0472 10.7429C16.8157 12.9178 15.5834 14.9559 13.5443 16.1332C10.1564 18.0893 5.82425 16.9285 3.86824 13.5406L3.65991 13.1797M2.9582 9.25456C3.1897 7.07964 4.42203 5.04154 6.46118 3.86423C9.84909 1.90822 14.1812 3.06901 16.1372 6.45691L16.3455 6.81776M2.91406 15.0538L3.5241 12.7771L5.80081 13.3871M14.2051 6.61039L16.4818 7.22043L17.0918 4.94372",
    stroke: "#5932F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCw05);
export default __webpack_public_path__ + "static/media/refresh-cw-05.71ae881b1ea6e7e86b54d34f5ccf8737.svg";
export { ForwardRef as ReactComponent };